import gql from 'graphql-tag';

const addFavoritePageQuery = gql`
  query addFavoritePageQuery($input: FavoritePagesQueryInput!) {
    favoritePages(input: $input) {
      total
      filter {
        offset
      }
      pages {
        total
      }
      hasNextPage
    }
  }
`;

export default addFavoritePageQuery;
